import * as React from "react"
import {
  RadioButtonFieldBlock,
  ThemeCss,
  VisuallyHidden,
} from "gatsby-interface"
import { build as text } from "@modules/locales/default"
import { StructuredLogLevel } from "@modules/graphql/types"

export type StructuredLogsFilterProps = {
  filterValue: string
  setFilterValue: React.Dispatch<React.SetStateAction<StructuredLogLevel>>
}

export function StructuredLogsFilter({
  filterValue,
  setFilterValue,
}: StructuredLogsFilterProps) {
  return (
    <div css={rootCss}>
      <RadioButtonFieldBlock
        name="filter"
        id="basic"
        label={<VisuallyHidden>{text.labels.filterLogs}</VisuallyHidden>}
        onChange={e => {
          setFilterValue(e.target.value as StructuredLogLevel)
        }}
        value={filterValue}
        options={[
          {
            label: (
              <React.Fragment>
                <VisuallyHidden>{text.labels.showAll}</VisuallyHidden>
                <span aria-hidden>{text.labels.all}</span>
              </React.Fragment>
            ),
            value: StructuredLogLevel.All,
          },
          {
            label: (
              <React.Fragment>
                <VisuallyHidden>{text.labels.showOnlyErrors}</VisuallyHidden>
                <span aria-hidden>{text.labels.onlyErrors}</span>
              </React.Fragment>
            ),
            value: StructuredLogLevel.Error,
          },
          {
            label: (
              <React.Fragment>
                <VisuallyHidden>{text.labels.showOnlyWarnings}</VisuallyHidden>
                <span aria-hidden>{text.labels.onlyWarnings}</span>
              </React.Fragment>
            ),
            value: StructuredLogLevel.Warning,
          },
        ]}
        optionsDirection="row"
      />
    </div>
  )
}

/* styles */

const rootCss: ThemeCss = theme => ({
  marginBottom: theme.space[5],
})
